import React from 'react';
import { auth } from '../../Api';
import { rememberAccount, myLocationsPath } from '../../utils/accountType';

// The menu's "My locations" of a Private account (utils/accountType.js): the owner's own client record's locations
// page (client-location.js). When the record is not known yet (opened before signing in again), the company is
// asked for it first.
class MyLocations extends React.Component {
	constructor(props) {
		super(props);
		this.state = { problem: null };
	}

	componentDidMount() {
		const path = myLocationsPath();
		if (path) {
			this.props.history.replace(path);
			return;
		}
		auth.getCompany({ id: localStorage.getItem('companyId') })
			.then((res) => {
				const account = res && res.data && res.data.code == 200 ? res.data.message.account : null;
				if (account) {
					rememberAccount(account);
				}
				const found = myLocationsPath();
				if (found) {
					this.props.history.replace(found);
				} else {
					this.setState({ problem: 'Your locations could not be found. Please sign in again.' });
				}
			})
			.catch(() => this.setState({ problem: 'Could not reach the server. Please try again.' }));
	}

	render() {
		return <p className="mt-3">{this.state.problem || 'Loading your locations...'}</p>;
	}
}

export default MyLocations;
